export default __webpack_public_path__ + "static/media/mortgageicon.982561a8.svg";